import { render, staticRenderFns } from "./indexManara.vue?vue&type=template&id=90a50514&scoped=true&"
import script from "./indexManara.vue?vue&type=script&lang=js&"
export * from "./indexManara.vue?vue&type=script&lang=js&"
import style0 from "./indexManara.vue?vue&type=style&index=0&id=90a50514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a50514",
  null
  
)

export default component.exports